/** Stable, bounded census sampling for ambient region residents. */
import { hash32, seedInt } from "@hyperlight/shared";

/**
 * Pick at most `limit` indices without materializing residents. Each result comes
 * from a disjoint census stratum, so the sample covers the whole identity range
 * instead of taking the first households in roster order.
 */
export function ambientResidentIndices(population: number, limit: number, salt: string): Uint32Array {
  const count = Math.min(Math.max(0, Math.floor(population)), Math.max(0, Math.floor(limit)));
  if (count === 0) return new Uint32Array();
  if (count === population) return Uint32Array.from({ length: count }, (_, index) => index);
  const seed = seedInt(salt);
  const indices = new Uint32Array(count);
  for (let stratum = 0; stratum < count; stratum++) {
    const start = Math.floor((stratum * population) / count);
    const end = Math.floor(((stratum + 1) * population) / count);
    indices[stratum] = start + hash32(seed, stratum, population, count) % Math.max(1, end - start);
  }
  return indices;
}
